module.exports = __webpack_public_path__ + "img/02755b0.jpg";